// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgChat0124 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M21 11.2804C20.7479 6.81338 17.0991 3.2465 12.5295 3.00003H12.0001C10.6026 2.9965 9.22396 3.31568 7.97656 3.9316C4.92788 5.42108 3.00144 8.46625 3.00003 11.798C2.99647 13.1641 3.32298 14.5118 3.95305 15.7312L3.00003 21L7.97656 19.6643C9.22396 20.2803 10.6026 20.5995 12.0001 20.5959C15.4083 20.5946 18.5234 18.7114 20.0471 15.7312C20.6771 14.5118 21.0036 13.1641 21 11.798V11.2804ZM8.63502 5.27935C9.68013 4.76333 10.8301 4.49708 11.9963 4.50002L12.5295 4.50003C16.2613 4.7035 19.2937 7.66783 19.5024 11.365L19.5 11.798C19.503 12.9269 19.234 14.037 18.7115 15.0483C17.4456 17.5243 14.8478 19.0948 11.9995 19.0959C10.8301 19.0989 9.68013 18.8326 8.64066 18.3194L8.49792 18.2579C8.20745 18.1502 7.88938 18.1347 7.58772 18.2156L4.89703 18.937L5.4291 15.9981C5.488 15.6725 5.43757 15.3366 5.28567 15.0426C4.76608 14.037 4.4971 12.9268 4.50002 11.8019C4.50119 9.0431 6.09816 6.51877 8.63502 5.27935Z"
				/>
			</Svg>
		);
	}
);
SvgChat0124.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgChat0124;
